import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faTiktok } from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";
import termsAndConditionsPdf from "../assets/Terms_and_Conditions_Luxe_Sparkle.pdf";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer_container">
        <div className="footer_about">
          <h3>Luxe Sparkle</h3>
          <p>
            Eco-conscious cleaning for healthy homes and workplaces across
            Auckland.
          </p>
        </div>

        <div className="footer_links">
          <h4>Quick Links</h4>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/services">Services</Link>
            </li>
            <li>
              <Link to="/gallery">Gallery</Link>
            </li>
            <li>
              <Link to="/FAQs">FAQs</Link>
            </li>
            <li>
              <Link to="/news">News</Link>
            </li>
            <li>
              <Link to="/booking">Booking</Link>
            </li>
          </ul>
        </div>

        <div className="footer_contact">
          <h4>Contact Us</h4>
          <p>Email : info@luxesparkle.co.nz</p>
          <p>Phone : 09 243 0470</p>
          <div className="social_icons">
            <a
              href="https://www.facebook.com/profile.php?id=61576447105564"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faFacebookF} size="2x" />
            </a>
            <a
              href="https://www.instagram.com/luxesparkleltd/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faInstagram} size="2x" />
            </a>
            <a
              href="https://www.tiktok.com/@luxe.sparkle"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faTiktok} size="2x" />
            </a>
          </div>
          <div className="footer_links_policy">
            <a href="/privacy-policy">Privacy Policy</a>
            <a
              href={termsAndConditionsPdf}
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
      <div className="footer_bottom">
        <p>© {new Date().getFullYear()} Luxe Sparkle. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
